import Vue from "vue";
import Router from "vue-router";
import Login from "@/modules/auth/Login";
import RecoveryPassword from "@/modules/auth/RecoveryPassword";
import ChangePassword from "@/modules/auth/ChangePassword";
import Register from "@/modules/auth/Register";
import CanceledAccount from "@/modules/auth/CanceledAccount";
import Onboarding from "@/modules/onboarding/Onboarding";
import SelectPlan from "@/modules/onboarding/SelectPlan";
import ConfigAccount from "@/modules/config/Account";
import HowTo from "@/modules/howto/HowTo";
import Canny from "@/modules/canny/Canny";

import Report from "@/modules/report/Report";

import Withdraw from "@/modules/withdraw/Withdraw";
import Sale from "@/modules/sale/Sale";
import Product from "@/modules/product/Product";

import Home from "@/modules/Home";
import Account from "@/modules/auth/Account";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Login",
      component: Login,
    },
    {
      path: "/recovery-password",
      name: "RecoveryPassword",
      component: RecoveryPassword,
    },
    {
      path: "/change-password/:rtoken",
      name: "ChangePassword",
      component: ChangePassword,
      props: true,
      meta: {
        breadcrumb: [
          {
            name: "Trocar a senha"
          }
        ]
      }
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
    },
    {
      path: "/onboarding",
      name: "Onboarding",
      component: Onboarding,
    },
    {
      path: "/onboarding-flow",
      name: "SelectPlan",
      component: SelectPlan,
    },
    {
      path: "/conta-cancelada",
      name: "CanceledAccount",
      component: CanceledAccount,
    },
    {
      path: "/tutoriais",
      name: "HowTo",
      component: HowTo,
      meta: {
        requiresLogin: true,
        breadcrumb: [
          {
            name: "Tutoriais",
          },
        ],
      },
    },
    {
      path: "/sugestoes",
      name: "Canny",
      component: Canny,
      meta: {
        requiresLogin: true,
        breadcrumb: [
          {
            name: "Sugestões",
          },
        ],
      },
    },
    {
      path: "/config/conta",
      name: "ConfigAccount",
      component: ConfigAccount,
      meta: {
        requiresLogin: true,
        permissionName: "config", // FIXME: arrumar permissão depois
        breadcrumb: [
          {
            name: "Configurações",
          },
          {
            name: "Conta",
          },
        ],
      },
    },
    {
      path: "/conta",
      name: "Account",
      component: Account,
      meta: {
        requiresLogin: true,
        breadcrumb: [
          {
            name: "Escolher conta",
          },
        ],
      },
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
      meta: {
        requiresLogin: true,
        breadcrumb: [
          {
            name: "Home",
          },
        ],
      },
    },
    {
      path: "/dash",
      name: "Report",
      component: Report,
      meta: {
        requiresLogin: true,
        permissionName: "report",
        breadcrumb: [
          {
            name: "Relatório",
          },
        ],
      },
    },
    {
      path: "/withdraw",
      name: "Withdraw",
      component: Withdraw,
      meta: {
        requiresLogin: true,
        permissionName: "withdraw",
        breadcrumb: [
          {
            name: "Saques",
          },
        ],
      },
    },
    {
      path: "/sale",
      name: "Sale",
      component: Sale,
      meta: {
        requiresLogin: true,
        permissionName: "sale",
        breadcrumb: [
          {
            name: "Vendas",
          },
        ],
      },
    },
    {
      path: "/product",
      name: "Product",
      component: Product,
      meta: {
        requiresLogin: true,
        permissionName: "product",
        breadcrumb: [
          {
            name: "Produtos",
          },
        ],
      },
    },
    {
      path: "*",
      name: "route.notfound",
      redirect: "/home",
    },
  ],
});
